import React from 'react';
import { AddDocumentDialog, IAddDocumentDialogProps } from '../schedule/AddDocumentDialog';

class AddHoursEarnedTypeDialog extends React.Component<IAddDocumentDialogProps> {
  constructor(props: IAddDocumentDialogProps) {
    super(props);
  }

  render() {
    return <AddDocumentDialog minWidth='270px' minHeight='360px' {...this.props} />;
  }
}

export default AddHoursEarnedTypeDialog;
